<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_toc_1"><span>Wish You Were Here</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">By Asta Idonea</p>
<p class="P_Normal"> </p>
<p class="P_Normal">The death of Oakley’s sister has left his family broken and buried beneath their grief. In an attempt to get out from underneath their pain, they rent an isolated cottage in the Cotswolds. For Oakley, it’s an exercise in futility. He doesn’t see much hope for things to get back to the way they used to be, and he’s bored and restless as he waits out the time until he can return to the city and university. All of that changes when he meets local boy Bobby, and the connection between them is instant. Within a few days, Oakley is ready to walk away from everything to stay with Bobby. However, Bobby has problems of his own, and they might be more than the budding romance can survive. But they might also give Oakley a new perspective on his own situation.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?5ea87ca6